import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ApiService } from "app/modules/shared/services/base/api.service";
import { ToastService } from "app/modules/shared/services/message/toast.service";
import { BaseForm } from "app/data/shared/models/base-form.interface";
import { RoleDto } from "app/modules/dashboard/modules/management/role/model/role.dto";
import { UtilService } from "app/modules/shared/services/util.service";
import { ExplorerService } from "app/modules/shared/services/explorer.service";
import { KlLoadingService } from "app/modules/shared/services/kl-loading.service";
import { TranslateService } from "@app/modules/shared/services/translate/translate.service";

@Component({
  selector: "kl-user-role-form",
  templateUrl: "./role-form.component.html",
  styleUrls: ["./role-form.component.scss"],
})
export class RoleFormComponent
  implements OnInit, AfterViewInit, OnDestroy, BaseForm
{
  @ViewChild("focusElement", { static: true }) private elementFocus: ElementRef;
  @ViewChild("UserRoleForm", { static: true }) private userRoleForm: any;
  @Input() tabId: string;
  @Input() listTabId: string;
  @Input() modalId: string;
  @Input() entity: RoleDto = new RoleDto();
  @Input() isReadOnly: boolean;
  @Input() mode: string;
  title = "";
  alertShow: boolean;
  alertType: string;
  alertMessage: string;
  errorShow = false;
  isOpenFirstAccordion = true;

  constructor(
    private apiService: ApiService,
    private utilService: UtilService,
    private translateService: TranslateService,
    private explorerService: ExplorerService,
    private klLoadingService: KlLoadingService,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    switch (this.mode) {
      case "add":
        this.entity.status = "ACTIVE";
        this.entity.type = "ROLE_USER";
        this.generateCode();
        this.title =
          this.translateService.instant("new") +
          " " +
          this.translateService.instant("role");
        break;
      case "view":
      case "edit":
        this.klLoadingService.hide();
        this.title = this.translateService.instant("role") + " - ";
        break;
    }
  }

  ngAfterViewInit() {
    this.elementFocus.nativeElement.focus();
  }

  formChange(event) {
    if (this.tabId) {
      this.explorerService.changeFormStatus({
        tabId: this.tabId,
        changeForm: event,
      });
    }
  }

  generateCode() {
    this.apiService
      .generateCode("role")
      .finally(() => {
        this.klLoadingService.hide();
      })
      .subscribe(
        (response) => {
          if (response === undefined) {
            this.handleError("error_data");
          } else {
            this.formChange(true);
            this.entity.code = response.value;
          }
        },
        (error) => this.handleError(error)
      );
  }

  clearForm() {
    this.elementFocus.nativeElement.focus();
    this.entity.status = "ACTIVE";
    this.entity.description = "";
    this.entity.type = "ROLE_USER";
  }

  commitSave(action: any) {
    if (this.userRoleForm.valid) {
      this.klLoadingService.show("saving");
      switch (action) {
        case "SAVE":
          switch (this.mode) {
            case "add":
              this.apiService.addData("role", this.entity).subscribe(
                (response) => this.handleResponse(response),
                (error) => this.handleError(error)
              );
              break;
            case "edit":
              this.apiService.updateData("role", this.entity).subscribe(
                (response) => this.handleResponse(response),
                (error) => this.handleError(error)
              );
              break;
          }
          break;
        case "SAVE_NEW":
          this.apiService.addData("role", this.entity).subscribe(
            (response) => this.handleNew(response),
            (error) => this.handleError(error)
          );
          break;
      }
    } else {
      this.errorShow = true;
      this.alertType = "error";
      this.alertMessage = "required_fields_must_be_entered";
    }
  }

  handleResponse(response) {
    this.klLoadingService.hide();
    this.toastService.toastSuccess();
    if (this.tabId) {
      this.formChange(false);
      this.explorerService.closeTab(this.tabId);
    } else if (this.modalId) {
      this.explorerService.closeModal(this);
    }
    if (this.listTabId) {
      this.explorerService.setRefreshEndProsseses(this.listTabId);
    }
  }

  handleNew(response) {
    this.errorShow = false;
    this.alertShow = false;
    this.formChange(false);
    this.klLoadingService.hide();
    this.toastService.toastSuccess();
    this.clearForm();
  }

  handleError(error) {
    this.errorShow = false;
    this.alertShow = true;
    this.alertType = "error";
    this.alertMessage = this.utilService.alertErrorMessage(error);
    this.klLoadingService.hide();
  }

  lockEntity(id: number) {
    return this.apiService.lockData("role", id);
  }

  unlockEntity() {
    this.apiService.unlockData("role", this.entity.id).subscribe();
  }

  ngOnDestroy() {
    if (this.mode === "edit") {
      this.unlockEntity();
    }
  }
}
